export default "__VITE_ASSET__pbEWvkys__"